/**
 * Type-safe environment configuration
 * All environment variables should be accessed through this module
 */

import type { EnvConfig } from '@/types/api.types';

const getEnvVar = (key: string, defaultValue?: string): string => {
  const value = import.meta.env[key] ?? defaultValue;
  if (value === undefined) {
    console.warn(`Missing environment variable: ${key}`);
    return '';
  }
  return value;
};

const getEnvBoolean = (key: string, defaultValue: boolean): boolean => {
  const value = import.meta.env[key];
  if (value === undefined) return defaultValue;
  return value === 'true' || value === '1';
};

const getEnvNumber = (key: string, defaultValue: number): number => {
  const value = import.meta.env[key];
  if (value === undefined) return defaultValue;
  const parsed = Number(value);
  return isNaN(parsed) ? defaultValue : parsed;
};

export const env: EnvConfig = {
  // App
  MODE: import.meta.env.MODE,
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,

  // API
  API_BASE_URL: getEnvVar('VITE_API_BASE_URL', 'http://localhost:8000'),
  API_TIMEOUT: getEnvNumber('VITE_API_TIMEOUT', 30000),

  // Feature Flags
  ENABLE_ANALYTICS: getEnvBoolean('VITE_ENABLE_ANALYTICS', false),
  ENABLE_ADMIN_PORTAL: getEnvBoolean('VITE_ENABLE_ADMIN_PORTAL', false),

  // Saudi-specific
  DEFAULT_LOCALE: getEnvVar('VITE_DEFAULT_LOCALE', 'ar-SA'),
  DEFAULT_CURRENCY: getEnvVar('VITE_DEFAULT_CURRENCY', 'SAR'),
};

// Freeze the env object to prevent modifications
Object.freeze(env);
